import { TransactionItemRowTypes } from './types';

import cn from './card.module.css';

const TransactionItemRow = ({ title, value }: TransactionItemRowTypes) => (
  <div className={cn.transactionItemRow}>
    <div className={cn.transactionItemRowTitle}>{title}</div>
    <div className={cn.transactionItemRowValue}>{value}</div>
  </div>
);

export default TransactionItemRow;
